export default __webpack_public_path__ + "static/media/LOGO (4).69a10e55.png";